import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import PostApi from 'web-app/api/post-api';

import * as Actions from './actions';

const fetchFeedInstitutions = action$ =>
    action$.ofType(Actions.fetchFeedInstitutions.type).mergeMap(() =>
        PostApi.getFeedInstitutions()
            .map(response => Actions.fetchFeedInstitutionsSuccess.action(response))
            .catch(e => Observable.of(Actions.fetchFeedInstitutionsFailed.action(e))),
    );

export default combineEpics(fetchFeedInstitutions);
